document.body.addEventListener('htmx:beforeSwap', function (event) {
    clearInterval(titleInterval);
    // clear all timers inside activeTimers
    activeTimers.forEach(timer => {
        clearInterval(timer);
    });
    activeTimers = [];
});

document.body.addEventListener('htmx:afterSwap', function (event) {
    const targetId = event.target.id;

    if (targetId === 'drawerBoxContent') {
        pendingBoxHandler(event);

        // check if the new content contains #redirectUrlMain div
        const redirectUrlMain = document.querySelector('#redirectUrlMain');
        if (redirectUrlMain) {
            const url = redirectUrlMain.textContent;
            // htmx get request to url and swap in mainContent
            htmx.ajax('GET', url, null, {
                historyUpdate: 'replace',
                target: document.querySelector('#mainContent')
            });
        }

    } else if (targetId === 'mainContent') {
        countdownInitializer();
        progressBarInitializer();
        bulmaSelectWrapper();
        remoteModalHandler();
        localModalHandler();
        pomodoroHandler();
        dropDownHandler();
        evolutionHandler();
        webpushHandler();

        const mainContent = document.querySelector('header');
        if (mainContent) {
            const pathInfo = event.detail.pathInfo;
            if (pathInfo) {
                let noScroll = pathInfo.responsePath.includes('no-scroll');

                if (!noScroll) {
                    mainContent.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }
    }

});

document.body.addEventListener('htmx:historyRestore', function (event) {
    // reload
    location.reload(false);
});